export const NAVIGATION = {
  name: 'Einstellungen',
  icon: 'fa-cog',
  path: '/module/settings/',
  children: [{
    name: 'Lizenz',
    path: '/module/settings/license',
    icon: 'fa-lock'
  }]
};
